import React from 'react';





class ImagePopup extends React.Component{
	constructor(props) {
    super(props);

  }

	componentDidMount() {
		
	}

	componentWillReceiveProps(nextProps) {
		
	}
	handleBack(e) {
		this.props.onClose();
	}


	
	
	render() {
		
    return (
    	<div className="feedpopup_wrapper">
    		<a onClick={this.handleBack.bind(this)} className="btn_remove"><img src="/static/img/appimg/icon_close_x.png" /></a>

   			 <div className="content">
   			 	<div className="img_content">
   			 		<img src={this.props.img}/>
   			 	</div>
   			 	
   			 </div>
   			 
   		</div>
      
    )
  }
}

export default ImagePopup;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/ImagePopup.js
 **/